/**
 * Unified quiz category -> { quiz route, PQP route } map.
 * Single source of truth for "where does this quiz's link/redirect go" instead of
 * hand-wiring QUIZ_ROUTES and APP_ROUTES.PQP_* separately at each call site.
 */
import { APP_ROUTES } from "~/constants/appRoutes";
import { QUIZ_CATEGORIES } from "~/constants/questionnaire";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import { PRODUCT } from "~/constants/products";

export const QUIZ_FUNNEL_MAP: Record<string, { quizRoute: string; pqpRoute: string }> = {
    [QUIZ_CATEGORIES.FACE_CREAM]: {
        quizRoute: QUIZ_ROUTES.ANTI_AGING_FACE_CREAM,
        pqpRoute: APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM,
    },
    [QUIZ_CATEGORIES.OESTRA_ENDO_PRE_PURCHASE]: {
        quizRoute: QUIZ_ROUTES.ENDOMETRIOSIS,
        pqpRoute: APP_ROUTES.PQP_ENDOMETRIOSIS,
    },
    [QUIZ_CATEGORIES.LIBIDA]: {
        quizRoute: QUIZ_ROUTES.LIBIDA,
        pqpRoute: APP_ROUTES.PQP_LIBIDA,
    },
    [QUIZ_CATEGORIES.NAD]: {
        quizRoute: QUIZ_ROUTES.NAD,
        pqpRoute: APP_ROUTES.PQP_NAD,
    },
    [QUIZ_CATEGORIES.OESTRA_POSTPARTUM_PRE_PURCHASE]: {
        quizRoute: QUIZ_ROUTES.POSTPARTUM,
        pqpRoute: APP_ROUTES.PQP_POSTPARTUM,
    },
    [QUIZ_CATEGORIES.BIOIDENTICAL_HRT]: {
        quizRoute: QUIZ_ROUTES.BIOIDENTICAL_HRT,
        pqpRoute: APP_ROUTES.PQP_HORMONE_IMBALANCE,
    },
    // The main hormone-imbalance/oestra quiz stores its completion flag under the
    // empty-string category (see QuizRedesign's `isOestra` handling and useSkipQuiz),
    // not QUIZ_CATEGORIES.OESTRA_CREAM — keep that same convention here.
    "": {
        quizRoute: QUIZ_ROUTES.HORMONE_IMBALANCE,
        pqpRoute: APP_ROUTES.PQP_HORMONE_IMBALANCE,
    },
};

/** Reverse lookup so call sites can keep passing a plain QUIZ_ROUTES.* href (as before) instead of a category. */
export const QUIZ_ROUTE_TO_CATEGORY: Record<string, string> = Object.fromEntries(
    Object.entries(QUIZ_FUNNEL_MAP).map(([category, { quizRoute }]) => [quizRoute, category])
);

/**
 * Products whose presence in the cart feeds `resolveQuizRedirectURL`'s `hasCheckoutOverrideProduct`
 * override (redirect to checkout instead of the PQP page). Currently just the
 * face-cream products; add a product's slug(s) here to opt it into the same override.
 */
export const PRODUCTS_TO_SHOW_CHECKOUT_INSTEAD_PQP: readonly string[] = [PRODUCT.FACE_CREAM, PRODUCT.FACE_CREAM_FINASTERIDE];
